import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-projects',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.scss']
})
export class ProjectsComponent implements OnInit {

  constructor(
    private router:Router,
    private titleService: Title
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle('MISK - Projects');
    
    setTimeout(() => {
      this.router.navigate(['/projects'])
    }, 600); 
    if (!localStorage.getItem('up')) {
      localStorage.setItem('up', 'no reload')
      location.reload()
    } else {
      localStorage.removeItem('up')
    }
  }

}
